export const LOCALES = {
    ENGLISH: 'en-US',
    PORTUGUES: 'pt-BR',
    ESPANOL: 'es',
}